import { generateUUID } from 'helpers/UuidHelper'

const SESSION_STORAGE_KEY = 'kn.browser.session.id'

let browserSessionId: string | null = null

export const getOrCreateBrowserSessionId = (): string => {
  if (browserSessionId) {
    return browserSessionId
  }

  const storedSessionId = window.sessionStorage.getItem(SESSION_STORAGE_KEY)

  if (storedSessionId) {
    browserSessionId = storedSessionId
    return browserSessionId
  }

  browserSessionId = generateUUID()
  window.sessionStorage.setItem(SESSION_STORAGE_KEY, browserSessionId)

  return browserSessionId
}

export const hashSessionId = async (sessionId: string): Promise<string> => {
  const encodedValue = new TextEncoder().encode(sessionId)
  const digest = await window.crypto.subtle.digest('SHA-256', encodedValue)

  return Array.from(new Uint8Array(digest))
    .map(value => value.toString(16).padStart(2, '0'))
    .join('')
}

export const resetBrowserSessionForTests = () => {
  browserSessionId = null
}
